import * as React from "react";

import Image from "next/image";
import { toast } from "react-toastify";
import { useRouter } from "next/router";
import { Formik } from "formik";
import Cookies from "universal-cookie/lib";
import * as Yup from "yup";
import {
  Grid,
  makeStyles,
  Typography,
  Box,
  Tabs,
  Tab,
} from "@material-ui/core";

import tether from "../../../../public/assets/images/paymentMethods/tether.png";
import bitcoin from "../../../../public/assets/images/paymentMethods/bitcoin.png";
import bnb from "../../../../public/assets/images/paymentMethods/bnb.png";
import BarcodeBTC from "../../../../public/assets/images/coins/btc.jpeg";
import BarcodeETH from "../../../../public/assets/images/coins/eth.jpeg";
import BarcodeTET from "../../../../public/assets/images/coins/tet.jpeg";
import RoundButton from "../../../common/button/RoundButton";
import AgapeForm from "../../../../components/common/form/AgapeForm";
import { emailRegex } from "../../../../helpers/validators";
import { postApiService } from "../../../../services/AgapeAPI";
import ShortLinkInput from "./ShortLinkInput";
import SuccessDialog from "./SuccessDialog";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "90%",
    margin: "auto",
    marginTop: "50px",
    // height: '100%',
    [theme.breakpoints.down("md")]: {
      maxWidth: "90%",
      marginTop: 0,
    },
    "& .PrivateTabIndicator-root-129": {
      backgroundColor: "#f7f7f7",
    },
  },
  payBtn: {
    borderRadius: "10px",
    margin: "5px",
  },
  copyBtn: {
    fontSize: "1.2rem !important",
    borderRadius: "6px",
    marginBottom: "20px !important",
  },
  padding: {
    marginTop: "20px",
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },
}));

const schema = Yup.object().shape({
  hash_id: Yup.string().required("پر کردن این فیلد اجباریست"),
  unit_count: Yup.string().required("پر کردن این فیلد اجباریست"),
  description: Yup.string().max(160, 'حد اکثر کارکتر مجاز "160" کارکتر میباشد'),
  email: Yup.string()
    .matches(emailRegex, "ایمیل وارد شده نامعتبر میباشد")
    .nullable()
    .notRequired(),
});

const fullWidth = true;
const star = true;
const cookies = new Cookies();

const CryptoPanel = ({ info, data, ...props }) => {
  const isLogin = cookies.get("isLoggedIn") === "1";
  const tetherId = info.find((x) => x.label === "تتر");

  const localData =
    typeof window !== "undefined" &&
    JSON.parse(localStorage.getItem("payment_methods_data"));

  const history = useRouter();
  const { id } = history.query;
  const [cryptoUnitId, handleChangeDigi] = React.useState(
    () => localData?.crypto_unit_id || tetherId || null
  );
  const ids = [3, 5, 1];
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [forClient, setForClient] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);

  const [binanceId, setBinanceId] = React.useState(ids[0]);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    setBinanceId(ids[newValue]);
  };

  // React.useEffect(() => {
  //   handleChangeDigi(info[1]);
  // }, [info]);

  const ttLink = "TPubV48adkvk1ts6D771fRaTi4Zo6HrQrD";
  const btcLink = "bc1qjyn43j4gawhg52s7dry0r9h3fj8na2eyx8t5wm";
  const bnbLink = "0xC8ED4381e2bD516Db97cF8BaEC8C0E07918bc127";

  React.useEffect(() => {
    setForClient(true);
    if (localData && localData.organization_id && localData.cryptoUnitId) {
      handleChangeDigi(() => localData.cryptoUnitId);
    }
  }, [localData]);

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChangeTab}
            centered
            indicatorColor="primary"
          >
            <Tab
              icon={
                <Image src={tether} alt="tether" width={100} height={100} />
              }
              label="Tether TRC20"
              {...a11yProps(2)}
            />
            <Tab
              icon={<Image src={bnb} alt="bnb" width={100} height={100} />}
              label="BNB"
              {...a11yProps(1)}
            />
            <Tab
              icon={
                <Image src={bitcoin} alt="bitcoin" width={100} height={100} />
              }
              label="Bitcoin"
              {...a11yProps(0)}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              width: "100%",
              flexDirection: "column",
            }}
          >
            {" "}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px",
              }}
            >
              {" "}
              <Image
                src={BarcodeTET}
                alt="BarcodeTET"
                width={200}
                height={200}
              />
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <ShortLinkInput link={ttLink} />
            </div>
          </div>
        </TabPanel>

        <TabPanel value={value} index={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px",
              }}
            >
              {" "}
              <Image
                src={BarcodeETH}
                alt="BarcodeETH"
                width={200}
                height={200}
              />
            </div>{" "}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <ShortLinkInput link={btcLink} />
            </div>
          </div>{" "}
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Grid
            item
            container
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px",
              }}
            >
              {" "}
              <Image
                src={BarcodeBTC}
                alt="BarcodeBTC"
                width={200}
                height={200}
              />{" "}
            </div>{" "}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <ShortLinkInput link={bnbLink} />
            </div>
          </Grid>
        </TabPanel>
      </Box>
      {forClient && (
        <Formik
          initialValues={{
            first_name: localData?.first_name,
            last_name: localData?.last_name,
            hash_id: localData?.hash_id,
            unit_count: localData?.unit_count,
            description: localData?.description,
            email: localData?.email,
            // crypto_unit_id: localData?.crypto_unit_id,
            mobile: localData?.mobile,
          }}
          validationSchema={schema}
          onSubmit={(values) => {
            if (isLogin) {
              const d = {
                // first_name: values.first_name,
                // last_name: values.last_name,
                unit_count: values.unit_count,
                hash_id: values.hash_id,
                crypto_unit_id: binanceId,
                // email: values.email,
                mobile: values.mobile,
                description: values.description,
                type: "organization",
              };

              postApiService(`crypto/organizations/${id}/paymnet`, d).then(
                () => {
                  toast.success("حمایت شما با موفقیت ثبت شد");
                  setOpenDialog(true);
                }
              );
            } else {
              localStorage.setItem(
                "payment_methods_data",
                JSON.stringify({
                  // first_name: values.first_name,
                  // last_name: values.last_name,
                  unit_count: values.unit_count,
                  hash_id: values.hash_id,
                  crypto_unit_id: { value: binanceId },
                  // email: values.email,
                  mobile: values.mobile,
                  description: values.description,
                })
              );
              history.replace(`/login?from=${history.asPath}`);
            }
          }}
        >
          {({
            values,
            errors,
            isSubmitting,
            isValid,
            handleSubmit,
            handleChange,
            handleBlur,
            handleReset,
            setFieldValue,
            validateField,
          }) => (
            <>
              <AgapeForm
                publics
                colXs={6}
                col={6}
                fields={[
                  // {
                  //   name: "crypto_unit_id",
                  //   // errors: errors.city,
                  //   fullWidth,
                  //   placeholder: "نوع  رمز ارز را انتخاب کنید",
                  //   value: cryptoUnitId,
                  //   // defaultValue: cryptoUnitId,
                  //   type: "select",
                  //   onChange: (e) => handleChangeDigi(() => e),
                  //   options: info,
                  //   // disabled: cities.length < 1,
                  // },
                  // {
                  //   name: "first_name",
                  //   fullWidth,
                  //   placeholder: "نام",
                  //   value: values.first_name,
                  //   errors: errors.first_name,
                  //   onChange: handleChange,
                  // },
                  // {
                  //   name: "last_name",
                  //   fullWidth,
                  //   placeholder: "نام خانوادگی",
                  //   value: values.last_name,
                  //   onChange: handleChange,
                  // },
                  // {
                  //   name: "email",
                  //   fullWidth,
                  //   placeholder: "ایمیل",
                  //   errors: errors.email,
                  //   // value: values.name,
                  //   value: values.email,
                  //   onChange: handleChange,
                  //   // disabled: true,
                  // },

                  {
                    name: "mobile",
                    // errors: errors.name,
                    fullWidth,
                    placeholder: "موبایل",
                    errors: errors.mobile,
                    // value: values.name,
                    value: values.mobile,
                    onChange: handleChange,
                    // disabled: true,
                  },
                  {
                    name: "hash_id",
                    errors: errors.hash_id,
                    star,
                    fullWidth,
                    placeholder: "Transaction ID",
                    value: values.hash_id,
                    // type: 'select',
                    onChange: handleChange,
                    // options: states,
                  },
                  {
                    name: "unit_count",
                    errors: errors.unit_count,
                    // isNumber,
                    star,
                    fullWidth,
                    placeholder: "تعداد واحد",
                    value: values.unit_count,
                    onChange: handleChange,
                  },

                  {
                    name: "description",
                    errors: errors.description,
                    // isNumber,
                    fullWidth,
                    placeholder: "توضیحات",
                    value: values.description,
                    onChange: handleChange,
                  },
                ]}
              />

              <div className={classes.padding}>
                <div
                  style={{
                    width: "250px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <RoundButton
                    customClassName={classes.payBtn}
                    onClick={handleSubmit}
                    disabled={!errors || !values.unit_count || !values.hash_id}
                  >
                    ثبت{" "}
                  </RoundButton>
                </div>
              </div>
              <SuccessDialog open={openDialog} setOpen={setOpenDialog} />
            </>
          )}
        </Formik>
      )}
    </>
  );
};

export default CryptoPanel;
